<template>
  <div class="Request">
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between">
          <b-col sm="6" md="5" cols="10" lg="5" class="my-1">
            <b-form-group
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Buscar"
                ></b-form-input>
                <!-- <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >X</b-button
                  >
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="6" md="7" cols="12" lg="5" class="my-1">
            <b-form-group
              label="Por Página"
              label-cols-sm="6"
              label-cols-md="3"
              label-cols-lg="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="md"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          show-empty
          small
          stacked="md"
          class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
          id="my-table"
          :items="ReportsTmp"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          :busy="isBusy"
        >
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay solicitudes de retiro</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay solicitudes con esas especificaciones</h6>
            </div>
          </template>
          <template v-slot:cell(amount)="row"> $ {{ row.value }} </template>
          <template v-slot:cell(status_payment_id)="row">
            <p v-if="row.value == 1">Pendiente</p>
            <p v-if="row.value == 2" style="color: green">
              Aprobado <v-icon name="check-circle"></v-icon>
            </p>
            <p v-if="row.value == 3" color="#CF173C">
              Rechazado <v-icon name="times-circle"></v-icon>
            </p>
            <!-- {{
            row.value == 1 ? "Pendiente" : row.value == 2 ? "Aprobada" : "Rechazada"
          }} -->
          </template>

          <template v-slot:cell(actions)="row">
            <!-- <b-button title="Detalles" size="sm" variant="white" @click="SelectReport(row.item)">
              <v-icon name="clipboard-list"></v-icon>
            </b-button> -->
            <router-link :to="{ name: 'Report', params: {id: row.item.id}}" v-if="row.item.status_payment_id != 2">
                <b-button title="Reportar depósito" size="sm" variant="white" >
              <v-icon name="file-alt"></v-icon>
            </b-button>
            </router-link>
            
            <b-spinner
                v-show="progress"
                small
                variant="primary"
                class="align-middle"
              ></b-spinner>
            <!-- <b-button
              title="Eliminar"
              size="sm"
              class="mr-1"
              variant="white"
              v-if="row.item.status_payment_id != 1"
              @click="deletePaymentReport(row.item)"
            >
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner
                v-show="hide"
                small
                variant="danger"
                class="align-middle"
              ></b-spinner>
            </b-button> -->
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-container>
    </b-card>
    
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Request",
  data() {
    return {
      progress: false,
      selected: null,
      hide: false,
      isBusy: false,
      ReportsTmp: [],
      PaymentReport: [],
      fields: [
        {
          key: "account.user.first_name",
          label: "Nombre",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "bank.name",
          label: "Banco a transferir",
          sortable: true,
        },
        {
          key: "bank.email",
          label: "Correo adjunto",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "amount",
          label: "Monto",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "status_payment_id",
          label: "Estado del depósito",
          sortable: true,
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataReports();
  },
  methods: {
    ...mapActions([
      "getWithdrawRequest",
      "changeactivateUser",
      "changePayStatus",
    ]),
    OpenImg(data) {
        console.log(data)
      window.open(data, "_blank");
    },
    SelectReport(data){
        this.selected = data
        this.$nextTick(() => {
        this.$bvModal.show("modal-request");
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataReports() {
      this.isBusy = true;
      this.getWithdrawRequest().then((response) => {
        if (response.code == 200) {
          this.ReportsTmp = response.data;
          this.totalRows = response.data.length;
          this.isBusy = false;
        }
      })
      .catch(error => {
          console.log(error)
          alert('Ha ocurrido un error, intente más tarde')
      })
    },
    changeStatus(pay, stats) {
      let stat = stats === 2 ? "aprobar" : "rechazar";
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas " + stat + " este depósito?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        showLoaderOnConfirm: true,
        confirmButtonText: 'Sí, seguro',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.progress = true
          let status =
            stats === 2
              ? "Se ha aceptado el depósito"
              : "Se ha rechazado el depósito";
          let form = {
            id: pay,
            status: stats,
          };
          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
          this.progress = false

                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.getDataReports();
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
              this.getDataReports();
            });
          console.log(form);
        }
      });
      
    },
    /* deletePaymentReport(data) {
      console.log(data)
      Swal.fire({
        title: "Atención",
        text:
          "¿Está seguro que desea eliminar el reporte de depósito de "+ data.name +"?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.hide = true;
          let form = {
            user_id: data.id,
            status: "2",
          };

          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.hide = false;
                this.getDataUser();
              }
            })
            .catch((error) => {
              console.log(error);
              this.hide = false;

              alert("Ocurrió un error, intente más tarde");
              this.getDataUser();
            });
        }
      });
    }, */
    
  },
};
</script>
<style scoped>
</style>